import { Body14Regular } from "@/components/typography/Body14Regular";
import { OrderDetailDto } from "@/types/dto/order-detail-dto";
import { Table } from "flowbite-react";
import { CustomCell } from "../CustomCell";
import { useState } from "react";
import { Button, Modal } from "flowbite-react";
import { orderService } from "@/services/order-service2";

interface Props {
  orderDetail: OrderDetailDto;
}

export const AdminOrderDetailReceiverTable: React.FC<Props> = ({
  orderDetail,
}) => {
  const headCellStyle = "font-medium text-gray-900 bg-gray-100";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [memo, setMemo] = useState(orderDetail.shippingMemo || "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleEditClick = () => {
    setMemo(orderDetail.shippingMemo || "");
    setIsModalOpen(true);
  };

  const handleSave = async () => {
    setLoading(true);
    setError("");
    try {
      await orderService.updateShippingMemo(orderDetail.id, memo);
      setIsModalOpen(false);
      window.location.reload(); // 새로고침으로 반영 (혹은 상위에서 refetch)
    } catch (e) {
      setError("저장에 실패했습니다.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="overflow-x-auto flex flex-col gap-[16px]">
      <div className="overflow-hidden border rounded-lg">
        <Table>
          <Table.Body>
            <Table.Row className="border-b border-gray-200">
              <Table.Cell
                colSpan={2}
                className={`${headCellStyle} w-[112px] p-0 h-[46px]`}
              >
                <CustomCell className="flex items-center justify-center mx-[16px] my-[12px]">
                  <Body14Regular className="text-semantic-text-secondary">
                    배송지 1
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
            <Table.Row className="border-b border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    운송장 번호
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] bg-primary-white border-l">
                <CustomCell className="h-fit flex flex-col gap-1">
                  <div className="flex items-center gap-2">
                    {orderDetail.noSong && orderDetail.cdDlvShopName && (
                      <Body14Regular className="text-semantic-text-body max-w-[1000px]">
                        {orderDetail.cdDlvShopName} {orderDetail.noSong}
                      </Body14Regular>
                    )}
                    <span
                      className={
                        orderDetail.shippingMemo
                          ? "text-xs text-blue-600"
                          : "text-xs text-gray-400"
                      }
                    >
                      {orderDetail.shippingMemo
                        ? orderDetail.shippingMemo.slice(0, 50)
                        : "배송 메모 없음"}
                    </span>
                    <button
                      className="px-2 py-0.5 text-xs text-blue-600 border border-blue-600 rounded hover:bg-blue-50 hover:font-bold focus:outline-none focus:ring-2 focus:ring-blue-200"
                      onClick={handleEditClick}
                      type="button"
                    >
                      수정
                    </button>
                  </div>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
            <Table.Row className="border-b border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    배송 상품
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] bg-primary-white border-l">
                <CustomCell className="h-fit">
                  <Body14Regular className="text-semantic-text-body max-w-[1000px] whitespace-break-spaces">
                    {orderDetail.cartItems.map((item) => item.name).join(", ")}
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
            <Table.Row className="border-b border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    받는 사람
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] bg-primary-white border-l">
                <CustomCell>
                  <Body14Regular className="text-semantic-text-body">
                    {orderDetail.receiverName}
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
            <Table.Row className="border-b border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    주소
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] bg-primary-white border-l">
                <CustomCell>
                  <Body14Regular className="text-semantic-text-body">
                    {orderDetail.receiverPostalCode}{" "}
                    {orderDetail.receiverAddress}{" "}
                    {orderDetail.receiverAddressDetail}
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
            <Table.Row className="border-b border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    연락처
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] bg-primary-white border-l">
                <CustomCell>
                  <Body14Regular className="text-semantic-text-body">
                    {orderDetail.receiverPhone}
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
            <Table.Row className="border-gray-200 ">
              <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    배송 요청사항
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="w-[680px] bg-primary-white border-l">
                <CustomCell>
                  <Body14Regular className="text-semantic-text-body">
                    {orderDetail.receiverMemo}
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
      {isModalOpen && (
        <Modal show={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <Modal.Header>배송 메모 수정</Modal.Header>
          <Modal.Body>
            <textarea
              className="w-full border rounded p-2 text-body-14 font-regular leading-body-14"
              value={memo}
              onChange={(e) => {
                if (e.target.value.length <= 50) setMemo(e.target.value);
              }}
              maxLength={50}
              rows={3}
              placeholder="배송 메모를 입력하세요 (최대 50자)"
            />
            <div className="text-right text-xs text-gray-400 mt-1">
              {memo.length}/50
            </div>
            {error && <div className="text-red-500 text-xs mt-2">{error}</div>}
          </Modal.Body>
          <Modal.Footer>
            <Button
              color="gray"
              onClick={() => setIsModalOpen(false)}
              disabled={loading}
            >
              취소
            </Button>
            <Button color="primary" onClick={handleSave} isProcessing={loading}>
              저장
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};
